// extracted by mini-css-extract-plugin
export var audioPlayer = "_p3-0";